import { render, staticRenderFns } from "./Search.page.vue?vue&type=template&id=083696e7&scoped=true&"
import script from "./Search.page.vue?vue&type=script&lang=js&"
export * from "./Search.page.vue?vue&type=script&lang=js&"
import style0 from "./Search.page.vue?vue&type=style&index=0&id=083696e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083696e7",
  null
  
)

export default component.exports